import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventiService {

  constructor(private http: HttpClient, private datePipe: DatePipe) { }

  public getList(page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.EventiSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        if (key == "dataEventoDa" || key == "dataEventoA") {
          filters[key] = this.datePipe.transform(filters[key], "yyyy/MM/dd");
        }
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.EventoDto[]>(`${environment.urls.base}/evento/list`,
        {
          params: searchParams
        });
  }

  public getEvento(idEvento: number) {
    return this.http
      .get<ModelEventiCalamitosi.EventoDto>(`${environment.urls.base}/evento/id/${idEvento}`);
  }

  public deleteEvento(idEvento: number) {
    return this.http.delete(`${environment.urls.base}/evento/delete/${idEvento}`);
  }

  public upsertEvento(eventoDto: ModelEventiCalamitosi.EventoDto) {
    return this.http
      .post<ModelEventiCalamitosi.EventoDto>(
        `${environment.urls.base}/evento/upsert`,
        eventoDto,
        {
          observe: 'response'
        }
      );
  }

  public dupicateEvt(eventoDupl: ModelEventiCalamitosi.EventoDto) {

    return this.http
      .post<ModelEventiCalamitosi.EventoDto>(
        `${environment.urls.base}/evento/duplicate`,
        eventoDupl,
        {
          observe: 'response'
        });
  }

  public getEventiListByRichiesta(idRichiesta: number, page: number, size: number, sort: string,) {

    let searchParams = new HttpParams();
    searchParams = searchParams.append('idRichiesta', `${idRichiesta}`);
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);

    return this.http
      .get<ModelEventiCalamitosi.EventoDto[]>(`${environment.urls.base}/evento/richiesta`,
        {
          params: searchParams
        });
  }

  public getEventoByRichiesta(idRichiesta: number) {

    let searchParams = new HttpParams();
    searchParams = searchParams.append('idRichiesta', `${idRichiesta}`);
    return this.http
      .get<ModelEventiCalamitosi.EventoDto[]>(`${environment.urls.base}/evento/evento-associato-richiesta`,
        {
          params: searchParams
        });
  }

  public getEventidaAssociare(page: number, size: number, sort: string, filters: ModelEventiCalamitosi.EventiSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        if (key == "dataEvento" && filters[key].includes("/")) {
          let data: string[] = filters[key].split('/');
          filters[key] = '';
          data.reverse();
          for (let index = 0; index < data.length; index++) {
            let next = index;
            const element = data[index];
            filters[key] += data[index];
            if ((next + 1) < data.length) filters[key] += "-";
          }
        }
        searchParams = searchParams.append(key, filters[key]);
      }
    }
    return this.http
      .get<ModelEventiCalamitosi.EventoDto[]>(`${environment.urls.base}/evento/list-eventi-non-associati-richieste`,
        {
          params: searchParams
        });
  }

  public inviaADipartimentoPC(idEvento: number) {
    return this.http.post<ModelEventiCalamitosi.EventoDto>(`${environment.urls.base}/evento/invia-a-dipartimento-pc`,
      idEvento,
      {
        observe: 'response'
      });
  }

  nonRiconoscereEmergenzaEvento(idEvento: number) {
    return this.http.post<ModelEventiCalamitosi.EventoDto>(`${environment.urls.base}/evento/rifiuta-stato-emergenza-evento`,
      idEvento,
      {
        observe: 'response'
      });
  }

  public numSegnalazioniNonIdoneeInvioEvento(idEvento: number) {
    if (idEvento != undefined && idEvento != null) {
      let searchParams = new HttpParams();
      searchParams = searchParams.append('idEvento', `${idEvento}`);
      return this.http.get<Number>(`${environment.urls.base}/evento/numero-segnalazioni-non-idonee-invio`,
        {
          params: searchParams
        });
    }
  }

  public getEntiDelegatiList(filter: {
    idEvento: number,
    page: number,
    size: number,
    sort: string,
    idEnte: string,
    description: string
  }) {
    let baseUrl = `${environment.urls.base}/evento/getEntiDelegatiEvento?JWTClaimsSet.claims=%7B%7D&idEvento=${filter.idEvento}&page=${filter.page}&size=${filter.size}&sort=${filter.sort}`;
    console.log(filter);
    if(filter.idEnte != "" && filter.idEnte != "null"){
      baseUrl += "&idEnte="+filter.idEnte;
    }
    if(filter.description != "" && filter.description != "null"){
      baseUrl += "&description="+filter.description;
    }
    return this.http.get<ModelEventiCalamitosi.EntiDelegatiEventoDTO[]>(baseUrl);
  }

  public postAddEnteDelegato(idEvento: number, idEnte: number, nodeCode: string, organId: number, description: string) {
    let body: any = {
        enti: [{
          idEnte: idEnte,
          nodeCode: nodeCode
        }],
        evento: {
          idEvento: Number(idEvento)
        }
      }

    if(!idEnte){
      body.enti[0].organId = organId;
      body.enti[0].descrizione = description;
    }

    return this.http.post<any>(
      `${environment.urls.base}/evento/upsertEnteEvento`,
      body
    );
  }

  public deletedEnteDelegato(idEnte: number, idEvento: number) {
    return this.http.delete<any>(
      `${environment.urls.base}/evento/removeEntiDelegati?idEnte=${idEnte}&idEvento=${idEvento}`
    );
  }
}
